var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { getGeometryStyle, getMinimumHeight, getMinimumWidth, getMaximumHeight, getMaximumWidth, getWidth, updateStylesheet, } from '../../helpers/styles';
import Image from '../Image';
var getMinHeightWidth = function (minimumSize) {
    return "\n  min-height: " + getMinimumHeight(minimumSize) + ";\n  min-width: " + getMinimumWidth(minimumSize) + ";";
};
var getMaxHeightWidth = function (maximumSize) {
    return "\n  max-height: " + getMaximumHeight(maximumSize) + ";\n  max-width: " + getMaximumWidth(maximumSize) + ";";
};
var StyledLabelImage = styled.div.attrs(function (props) { return ({
    className: props.type,
}); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  ", "\n    ", "\n    box-sizing: ", ";\n  color: ", ";\n  display: ", ";\n  ", "\n  background-color: ", "\n  border: ", ";\n  border-color: ", ";\n\n  padding-left: ", ";\n  padding-right: ", ";\n  ", ";\n  ", "\n"], ["\n  ", "\n  ",
    "\n    ",
    "\n    box-sizing: ", ";\n  color: ",
    ";\n  display: ", ";\n  ", "\n  background-color: ",
    "\n  border: ", ";\n  border-color: ", ";\n\n  padding-left: ", ";\n  padding-right: ", ";\n  ", ";\n  ",
    "\n"])), function (_a) {
    var geometry = _a.attributes.geometry;
    return getGeometryStyle(geometry);
}, function (_a) {
    var attributes = _a.attributes;
    return attributes &&
        attributes.minimumSize &&
        getMinHeightWidth(attributes.minimumSize);
}, function (_a) {
    var attributes = _a.attributes;
    return attributes &&
        attributes.maximumSize &&
        getMaxHeightWidth(attributes.maximumSize);
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.label.boxSizing;
}, function (_a) {
    var windowTheme = _a.windowTheme, disabled = _a.disabled, fontColor = _a.fontColor;
    return disabled
        ? windowTheme.label.disabledColor
        : fontColor !== null && fontColor !== void 0 ? fontColor : windowTheme.label.color;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.label.display;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return getWidth(windowTheme.label.width);
}, function (_a) {
    var attributes = _a.attributes, windowTheme = _a.windowTheme, backgroundColor = _a.backgroundColor;
    var _b;
    return backgroundColor
        ? backgroundColor + " !important"
        : (_b = attributes.backgroundColor) !== null && _b !== void 0 ? _b : windowTheme.label.backgroundColor;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.label.border;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.label.borderColor;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.label.paddingLeft;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.label.paddingRight;
}, function (_a) {
    var attributes = _a.attributes;
    return attributes.styleSheet;
}, function (_a) {
    var attributes = _a.attributes, type = _a.type;
    return attributes &&
        attributes.styleSheet &&
        updateStylesheet(attributes.styleSheet._, type);
});
var LabelImage = function (props) {
    var identifier = props.identifier, restProps = __rest(props, ["identifier"]);
    var geometry = props.attributes.geometry;
    return (React.createElement(StyledLabelImage, __assign({}, restProps),
        React.createElement(Image, { width: geometry.width, height: geometry.height, imageName: props.attributes.pixmap })));
};
export default LabelImage;
var templateObject_1;
//# sourceMappingURL=index.js.map